import { render, staticRenderFns } from "./ViewRequest.vue?vue&type=template&id=3492eadf&"
import script from "./ViewRequest.vue?vue&type=script&lang=js&"
export * from "./ViewRequest.vue?vue&type=script&lang=js&"
import style0 from "./ViewRequest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports